// Lib
import * as _ from 'lodash';
import { put, call, takeLatest } from "redux-saga/effects";
import { parseAPICompleteness } from "./utils"

// Constants
import * as ACTIONS from "./actionTypes";

// Types
import { ActionGetCompletenessAPI, getCompletenessAPIError, getCompletenessAPISuccess } from './actions';
import { CompletessInfo } from './types';

// Functions
import { createAPINetworkInstance } from '../../../../../../common/api';


function* getCompleteness(action: ActionGetCompletenessAPI) {
    try {
        const { iddealer } = action
        const { data } = yield call(createAPINetworkInstance().get, `/dealer/${iddealer}/profilecompleteness`);
        const completessInfo: CompletessInfo = parseAPICompleteness(data);
        yield put(getCompletenessAPISuccess(completessInfo));
    } catch (err) {
        yield put(getCompletenessAPIError(err));
    }
}

export default function* completenessSagas() {
    yield takeLatest(ACTIONS.GET_COMPLETENESS_API_REQUEST, getCompleteness);
}
